export async function fetchCssVariables(chainId: string, lang: string): Promise<{}> {
  const url = `${import.meta.env.VITE_BE_API_DOMAIN}chains/css/${chainId}/${lang}`;
  
  const response = await fetch(url);
  if (!response.ok) throw new Error('Failed to fetch css data');
  return response.json();
}

export async function fetchFonts(chainId: string, lang: string): Promise<[]> {
  const url = `${import.meta.env.VITE_BE_API_DOMAIN}chains/css/fonts/${chainId}/${lang}`;
  
  const response = await fetch(url);
  if (!response.ok) throw new Error('Failed to fetch font data');
  return response.json();
}
